import React from 'react';
import noonConfig from '@com/core/noon/noonConfig';

// Includes both simple and creative icons
export type TIconName =
    | 'constactless_delivery_usp'
    | 'trusted_shipping_usp_v2'
    | 'free_returns_usp'
    | 'market_ar'
    | 'express_ar'
    | 'market_en'
    | 'express_en'
    | 'discount'
    | 'secure'
    | 'same_day_delivery'
    | 'non_returnable'
    | 'free_returns'
    | 'emi'
    | 'seller'
    | 'warranty'
    | 'prepaid_only_items'
    | 'other_offers'
    | 'help_v2'
    | 'check'
    | 'cart'
    | 'secure_usp';

type TProps = {
    name: TIconName;
    classValue: string;
};

const Icon = (props: TProps): JSX.Element => {
    const { classValue, name } = props;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <img src={`${noonConfig.urls.imgBase}icons/${name}.svg`} alt={name} className={classValue} />;
};

export default Icon;
